var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      directives: [
        {
          name: "drawerloading",
          rawName: "v-drawerloading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: _vm.titleInternalKey ? _vm.$t(_vm.titleInternalKey) : _vm.title,
        "before-close": _vm.beforeCloseHandle,
        visible: _vm.drawerVisible,
        direction: "rtl",
        size:
          parseInt(_vm.size) > parseInt(_vm.maxWidth) ? _vm.maxWidth : _vm.size,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
      },
    },
    [
      _c(
        "yxt-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c(
            "yxt-form-item",
            {
              staticClass: "mb0",
              attrs: { label: _vm.$t("pc_ulcd_lbl_remarkperson") },
            },
            [
              _c(
                "yxt-radio-group",
                {
                  attrs: { direction: "row" },
                  model: {
                    value: _vm.form.remarkType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "remarkType", $$v)
                    },
                    expression: "form.remarkType",
                  },
                },
                [
                  _c("yxt-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("pc_ulcd_lbl_instructorremark"))),
                  ]),
                  _c(
                    "yxt-radio",
                    { attrs: { label: 5 } },
                    [
                      _vm._v(_vm._s(_vm.$t("pc_ulcd_lbl_designpersonremark"))),
                      _vm.form.remarkType === 5
                        ? _c(
                            "yxt-button",
                            {
                              staticClass: "ml16",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.personSelectDialog = true
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("pc_ulcd_lbl_designperson")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            { attrs: { prop: "users" } },
            [
              _vm.form.users.length > 0 && _vm.form.remarkType === 5
                ? _vm._l(_vm.form.users, function (user) {
                    return _c(
                      "yxt-tag",
                      {
                        key: user.id,
                        staticClass: "ml5",
                        attrs: { type: "info", closable: "" },
                        on: {
                          close: function ($event) {
                            return _vm.delUser(user)
                          },
                        },
                      },
                      [
                        _c("yxtbiz-user-name", {
                          attrs: { name: user.fullname },
                        }),
                      ],
                      1
                    )
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.beforeCloseHandle } },
            [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_cancel")))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitHandle } },
            [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_done")))]
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            size:
              parseInt(_vm.selectorSize) > parseInt(_vm.maxWidth)
                ? _vm.maxWidth
                : _vm.selectorSize,
            "destroy-on-close": "",
            "append-to-body": "",
            visible: _vm.personSelectDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.personSelectDialog = $event
            },
          },
        },
        [
          _c("yxt-user-selector", {
            ref: "selector",
            attrs: {
              data: _vm.users,
              limit: 30,
              tabs: _vm.tabs,
              enableGroupCorp: !!_vm.groupOrgFlag,
              dataPermissionCode: _vm.groupOrgFlag
                ? _vm.groupDataPermissionCode
                : _vm.dataPermissionCode,
              functionCode: _vm.groupOrgFlag
                ? _vm.groupFunctionCode
                : _vm.functionCode,
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.cancelUser } },
                [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_cancel")))]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.getUsers } },
                [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_done")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }